module.exports = __webpack_public_path__ + "img/recommend-tag.4949436.gif";